import React from 'react'

import { SettingsIcon } from '@chakra-ui/icons'

import { Tooltip } from '@chakra-ui/react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'

const App = () => {
    return (
        <div className='flex relative dark:bg-main-dark-bg'>
            <div className='fixed right-4 bottom-4' style={{ zIndex: '1000' }}>
                <Tooltip label='Ustawienia'>
                    <button type='button'
                        onClick={() => { }}
                        className='text-3x1 p-3
              hover:drop-shadow-xl
               text-2xl
               hover:bg-light-gray
               text-white'
                        style={{ background: 'blue', borderRadius: '50%' }}>
                        <SettingsIcon />
                    </button>
                </Tooltip>
            </div>
        </div>
    )
}

export default App